var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-error",class:{admire: _vm.isStreamer}},[_vm._v("\n  暂不支持查看此消息\n")])}
var staticRenderFns = []

export { render, staticRenderFns }